<template lang="html">
    <div>
        <template>
            <p>La demande que vous souhaitez modifier est liée à un symbole.
                 Voulez vous délier cette demande de son symbole afin de la modifier séparement ?</p>


        </template>

    </div>
</template>

<script>
import Single from '../../symbols/list/Single.vue'
export default {
        data() {
            return {
                title:          'Cette demande est liée à un symbole',
                icon:           'autorenew',
                warning:        true,
                valid_label :   'Délier la demande de son symbole',
                cancel_label :  'Modifier le symbole',
            }
        },
        props: {
    		params: {
    			required: true
    		}
    	},
        methods: {
            onClose(type) {
                window.location.hash = '';
                if (type ==='cancel'){
                    this.$eventHub.$emit('open-modal', Single,{ id: this.params.symbol_id, isEditing:true});
                }
                this.$eventHub.$emit('close-modal2');

            },

            onValidate() {
                this.axios.delete(`/api/requests/${this.params.request_id}/symbol`)
                    .then(response => {
                        this.$eventHub.$emit('close-modal2')
                        this.$eventHub.$emit('go-to-request',{id: this.params.request_id});

                    })
                    .catch(error => {
                        console.log(error.response.data || error)
                    })
            }
        }

    }
</script>

<style lang="stylus" scoped>
div {
    padding: 1rem 4rem;
}
</style>



// WEBPACK FOOTER //
// src/views/products/single/Unlink.vue